<template>
  <div class="d-flex flex-column align-stretch flex-grow-1 flex-shrink-1" style="overflow-y: hidden">
    <div class="text-center mt-1 grey--text py-1" style="font-size: 14px;">
      Report a problem with a lead <router-link :to="{ name: 'billing/history/dispute' }">here</router-link>.
    </div>

    <div 
      class="d-flex flex-column align-stretch mt-2 flex-grow-1 flex-shrink-1"
      style="overflow-y: auto"
    >
      <HistoryList
        :history="history"
        class="py-0 rounded-lg"
      />
      <div class="d-flex justify-center mt-3 mb-1">
        <v-btn color="primary" @click="addMonth">30 days More</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HistoryList from './components/HistoryList'

export default {
  name: 'BillingHistoryTab',

  components: { HistoryList },

  data: () => ({
    extra_months: 0,
  }),

  computed: {
    ...mapGetters('billing', ['history']),
  },

  methods: {
    ...mapActions('billing', ['loadHistory']),

    addMonth() {
      this.extra_months += 1
      this.reload()
    },

    reload() {
      const { extra_months } = this
      this.loadHistory({ extra_months })
    }
  },

  created() {
    this.reload()
  },
}
</script>